var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$getConstRole('ROLE_CLIENT') == _vm.role)?_c('ClientBookingView'):_vm._e(),(_vm.$getConstRole('ROLE_AGENT') == _vm.role)?_c('AgentBookingView'):_vm._e(),(_vm.$getConstRole('ROLE_ADMIN') == _vm.role)?_c('AdminBookingView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }